import { render, staticRenderFns } from "./FormularioCampoComponent.vue?vue&type=template&id=fcba862e&scoped=true"
import script from "./FormularioCampoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCampoComponent.vue?vue&type=script&lang=js"
import style0 from "./FormularioCampoComponent.vue?vue&type=style&index=0&id=fcba862e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcba862e",
  null
  
)

export default component.exports